    <div fxLayout="row" fxLayoutAlign="space-between center">
        <h2 class="row">{{ "recalculate-queue.title" | translate }}</h2>
        <div *ngIf="topMenuIcons.length > 0">
    
            <button mat-raised-button *ngFor="let action of topMenuIcons" [routerLink]="action.routerLink"
                (click)="this[action.clickMethod]()">
                <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
            </button>
        </div>
    </div>
    <form [formGroup]="detailForm"  style="min-width: 400px;">
        <div fxLayout="column" *ngIf="queue && queue.length > 0">
            <li *ngFor="let element of queue.slice(0, 10)">
                <label>{{ element.tunnelSectionName }}</label>
            </li>
            <li *ngIf="queue.length > 10">..... (total of {{queue.length}} )</li>
        </div>
        <div fxLayout="column" *ngIf="!queue || (queue && queue.length === 0)">
        <mat-label> {{ "recalculate-queue.nothing" | translate }}
        </mat-label></div>
    </form>

